export default `
  fragment ContentAreaElement on BoothDesignContentAreaElement {
    contentRichtextHtml {
      ...CommonLocalizableString
    }
    image: contentImage {
      ...CommonLocalizableImage
    }
    video: contentVideo {
      ...CommonLocalizableVideo
    }
    pdf: contentPdf {
      ...CommonLocalizableFile
    }
    thumbnailImage {
      ...CommonLocalizableImage
    }
    kind: contentType
    name: keyName
  } 
`;
